<template>
    <div class="page-wrapper" id="scroll_top">
        <section class="hero_content" v-if="pageIsLoaded">
            <div class="data">
                <h2 class="title small" data-inview="fadeInUp" data-delay="200">
                    {{ content.subhero.surtitre }}
                </h2>
                <h1 class="title medium" data-inview="fadeInUp" data-delay="300">
                    <span v-html="content.subhero.titre"></span>
                </h1>
            </div>
            <div class="img" data-inview="revealRight" data-delay="200">
                <img :src="content.subhero.image.url" :alt="content.subhero.image.titre" />
            </div>
            <a href="#next" v-scroll-to:-120
                ><svg
                    fill="none"
                    class="arrow"
                    viewBox="0 0 13 26"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="m11.6412 17.9322-4.17083 4.2832v-22.2154h-1.94081v22.2154l-4.17082-4.2832-1.35874 1.395 6.5 6.6728 6.5-6.6728z"
                    /></svg
            ></a>
        </section>

        <div v-if="pageIsLoaded">

            <section class="img_txt" id="next" v-for="(item, i) in servicesList" :key="i" :class="{dark_switch: i % 2 === 1}">
                <div class="data">
                    <h3 class="title small" data-inview="fadeInUp" data-delay="200">
                        {{ item.page.titre }}
                    </h3>
                    <h2 class="title medium" data-inview="fadeInUp" data-delay="300">
                        <span v-html="item.page.entete1.titre"></span>
                    </h2>
                    <p class="regular-text" data-inview="fadeInUp" data-delay="400">
                        <span v-html="item.page.entete1.texte"></span>
                    </p>
                    <router-link
                        :to="item.page.jsonUrl"
                        class="cta"
                        data-inview="fadeInUp"
                        data-delay="500"
                    >
                        <p class="regular-text">{{ $t('En savoir plus') }}</p>
                        <img src="@/assets/img/arrow-right.svg" alt="arrow right" v-if="i % 2 === 0" />
                        <img src="@/assets/img/arrow-right-dark.svg" alt="arrow right" v-else />
                    </router-link>
                </div>
                <div class="img" data-inview="revealRight" data-delay="200">
                    <img
                        :src="item.page.imageSimple1.url"
                        :alt="item.page.imageSimple1.titre"
                    />
                </div>
            </section>

        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import GLightbox from 'glightbox'
// import Flickity from 'flickity'

export default {
    data() {
        return {
            lightboxelement: null,
        }
    },

    watch: {
        pageIsLoaded: {
            handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data
                    setTimeout(() => {
                        this.lightboxelement = GLightbox
                        GLightbox()

                        setTimeout(() => {
                            // this.teamCarousel.resize()
                        }, 1755)
                    }, 1055)
                }
            },
            immediate: true,
        },
    },

    computed: {
        servicesList() {
            if (!this.globalsIsLoaded) {
                return []
            }

            return this.globals.servicesEntry.data
        },
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
}
</script>

<style lang="scss" scoped></style>
